<template>
  <div>
    <div class="main-title">充值卡统计表
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="收支日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索卡号"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="card_no"
          label="充值卡卡号"
          width="170">
        </el-table-column>
        <el-table-column
          prop="card_name"
          label="持卡人">
        </el-table-column>
        <el-table-column
          prop="recharge"
          label="充值金额">
        </el-table-column>
        <el-table-column
          prop="pay_money"
          label="实付金额">
        </el-table-column>
        <el-table-column
          prop="free_money"
          label="赠送金额">
        </el-table-column>
        <el-table-column
          prop="free_rate"
          label="赠送率">
        </el-table-column>
        <el-table-column
          prop="consume_2"
          label="科二消费">
        </el-table-column>
        <el-table-column
          prop="consume_2_real"
          label="科二实付">
        </el-table-column>
        <el-table-column
          prop="consume_2_free"
          label="科二赠送">
        </el-table-column>
        <el-table-column
          prop="consume_3"
          label="科三消费">
        </el-table-column>
        <el-table-column
          prop="consume_3_real"
          label="科三实付">
        </el-table-column>
        <el-table-column
          prop="consume_3_free"
          label="科三赠送">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="余额">
        </el-table-column>
        <el-table-column
          prop="balance_real"
          label="余额实际">
        </el-table-column>
        <el-table-column
          prop="balance_free"
          label="余额赠送">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'report_card',
      searchForm: {
        query: '',
        daterange: []
      },
      sumProps: [
        'recharge',
        'pay_money',
        'free_money',
        'consume_2',
        'consume_2_real',
        'consume_2_free',
        'consume_3',
        'consume_3_real',
        'consume_3_free',
        'balance',
        'balance_real',
        'balance_free'
      ]
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'card_name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/report/Card.vue